import axios from "axios";
import { getAuthData, clearAuthData } from "../utils/authStorage";
import { appRouter } from "../constants/routerConstant";
import { encrypt, decrypt } from "../utils/cryptoUtil";

export const apiRequest = async ({ portal, method, endpoint, data = null, params = {}, headers = {} }) => {
  const API_BASE_URL = portal === "gti" ? process.env.REACT_APP_API_URL_GTI : process.env.REACT_APP_API_URL_DMQ;
  try {
    const authData = getAuthData();
    const token = authData?.token;
    const payload = process.env.REACT_APP_ENABLE_ENCRYPTION === "true" ? { data: await encrypt(JSON.stringify(data)) } : data;

    const config = {
      method,
      url: `${API_BASE_URL}${endpoint}`,
      data: payload,
      params,
      headers: {
        // "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...headers, // allow overrides
      },
    };

    const response = await axios(config);
    let responseData = response.data;

    // ⏬ Decrypt response if encryption enabled
    if (process.env.REACT_APP_ENABLE_ENCRYPTION === "true") {
      if (responseData?.data) {
        try {
          const decryptedStr = await decrypt(responseData.data);
          responseData = JSON.parse(decryptedStr);
        } catch (err) {
          console.error("Response decryption failed:", err);
        }
      }
    }

    return responseData;
  } catch (error) {
    const status = error.response?.status;
    if (status === 401) {
      console.warn("Unauthorized: Logging out user…");
      clearAuthData();

      // Redirect to login page
      if (typeof window !== "undefined") {
        window.location.href = appRouter.DMQLogin || "/login";
      }
    }
    console.log("API Request Error:", error.response?.data || error.message);
    throw error.response?.data || error.message;
  }
};
